// The sealy account/utility side-nav shell shared by the password-reset
// documents: the capped-width wrapper, the customer-service side nav (when the
// NavBar snippet exists), and the content title. The title renders WITHOUT the
// shared AccountContentTitle's "Talk to Sleep Expert" phone line — sealy's
// content_title partial rendered only the headline. The side nav SSRs fully
// collapsed (expandFirstLinkList=false) and owns its own accordion toggle
// (selfManaged): the group starts closed and opens only on click, so the
// initial render carries no accordion--is-active state.
import { Immutable } from "immer";
import React from "react";
import { SideNav } from "tsi-common-react/src/apps/customer-account/SideNav/index";

import { templates } from "@reactivated";

type IProps = Immutable<{
    hasNav: boolean;
    sideNav: templates.PasswordResetDocumentTemplate["side_nav"];
    title: string;
}> & {
    children?: React.ReactNode;
};

export const AccountShell = (props: IProps): React.JSX.Element => (
    <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
        {props.hasNav && (
            <div className="l-side-nav">
                <SideNav
                    items={props.sideNav}
                    expandFirstLinkList={false}
                    selfManaged={true}
                />
            </div>
        )}

        <div className="l-side-nav-content">
            <div className="content-title">
                <h1 className="content-title__headline">{props.title}</h1>
            </div>

            <div className="content__copy--full-width">{props.children}</div>
        </div>
    </div>
);
